module.exports = require('./helpers/bundle-url').getBundleURL('cU4yt') + "logo-dark.eefe0b7f.svg";